<template>
    <v-app>
        <v-main class="content mx-0 mx-md-2 pt-16">
            <v-container fluid class="mx-1 mt-2">
                <v-row no-gutters justify="center">
                    <v-col cols="6">
                        <work-space-invite @accept="onAccept" @reject="onReject" :token="token"></work-space-invite>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
}
</style>
<script>
import WorkSpaceInvite from "../components/invite/WorkSpaceInvite.vue";
import {mapActions} from "vuex";
export default {
    components: {
        WorkSpaceInvite
    },
    name: 'WorkSpaceInvitePage',
    props:{
    },
    data() {
        return {
        }
    },
    created() {

    },
    methods: {
        ...mapActions('workspace', ['LOAD_WORK_SPACE', 'CLEAR_WORK_SPACE']),
        ...mapActions('workspaceList', ['LOAD_WORKSPACES']),
        onAccept(data){
            this.$router.push({name: 'Main'},  () => {
                this.LOAD_WORKSPACES();
                this.LOAD_WORK_SPACE(data.work_space_id);
            });
        },
        onReject(){
            this.$router.push({name: 'Main'});
        }
    },
    computed:{
        token(){
            return this.$route.params.token;
        }
    }
}
</script>
<!--<style src="./styles/Invite.scss" lang="scss"/>-->